import { Button, FormControl, OutlinedInput, InputLabel, FormHelperText, Stack } from "@mui/material";
import React from "react";
import Modal, { CommonModalProps } from "..";
import { useTranslation } from "react-i18next";

export type ModalRenameElementProps = {
  onClose?: (props: CloseClbProps) => void;
};
type CloseClbProps = {
  collectionName: string;
};

export type ModalRenameCollectionProps = CommonModalProps<ModalRenameElementProps>;

const ModalRenameCollection = React.forwardRef<any, ModalRenameCollectionProps>((props, ref) => {
  const { t } = useTranslation();
  const { closeModal, onClose } = props;
  const [collectionName, setCollectionName] = React.useState("Stranger Things");

  const handleCollectionNameChange: React.ChangeEventHandler<HTMLTextAreaElement> = (e) => {
    setCollectionName(e.target.value);
  };

  const handleRenameClick: React.MouseEventHandler = () => {
    closeModal();
    onClose && onClose({ collectionName });
  };

  return (
    <Modal
      title={t("modal:title.editMyListName")}
      reference={ref}
      closeModal={closeModal}
      width={504}
      footer={
        <Stack direction="row" justifyContent="space-between">
          <Stack direction="row" spacing={1.5}>
            <Button onClick={closeModal}>{t("common:cancel")}</Button>
            <Button onClick={closeModal} variant="outlined" color="error">
              {t("button:deleteList")}
            </Button>
          </Stack>
          <Button disabled={collectionName === ""} onClick={handleRenameClick} variant="contained">
            {t("button:confirmChanges")}
          </Button>
        </Stack>
      }
    >
      <FormControl sx={{ mb: 1 }}>
        <InputLabel shrink htmlFor="rename-collection">
          {t("field:label.listName")}
        </InputLabel>
        <OutlinedInput
          placeholder={t("field:placeholder.createCollectionName")}
          value={collectionName}
          onChange={handleCollectionNameChange}
          id="rename-collection"
        />
        <FormHelperText>{t("field:helper.collectionNameMaxLength", { count: 40 })}</FormHelperText>
      </FormControl>
    </Modal>
  );
});

export default ModalRenameCollection;
